import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function getVersionList() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/version`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function addVersionList(data) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/version`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateVersionData(data) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/version`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function deleteVersion(id) {
    try {
        const response = await serviceContext.del(`${BASE_URL_M_ADMIN}madmin/version/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getOperatorOfAllLicence(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/LicenseVersion/listByOperator/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error
    }
}

export async function addLicenceAndWhiteLabel(data) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/LicenseVersion/AddOperatorLicense`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error
    }
}